<template>
  <div :style="{ height: height }" style="background: #f3f4f6">
    <!-- 多语言切换 -->
    <eDSCompLanguage />

    <v-layout class="account_infolist" row wrap>
      <v-flex class="info_name_job_phone" xs12>
        <div class="img-bg">
          <img :src="myinfo.photo" onerror="this.style.display='none'" />
        </div>

        <div class="name_job_phone">
          <span class="info_name">{{ myinfo.name }}</span>
          <span class="info_job">{{ myinfo.job }}</span>
          <p class="info_phone">{{ myinfo.phone }}</p>
        </div>
      </v-flex>
      <v-flex class="info_button" xs12 v-for="(button, index) in myinfo.buttons" :key="index"
        @click="button.func(button.params)">
        <div>
          <span class="info_title">{{ button.title }}</span>
          <v-icon class="info_button_icon_right">keyboard_arrow_right</v-icon>
        </div>
      </v-flex>
      <v-flex class="info_button" style="margin-top: 10px; margin-bottom: 10px" xs12 @click="onSetPassword()">
        <div>
          <span style="height: 28px; line-height: 28px">
            <img style="height: 24px; width: 24px; vertical-align: middle" src="imgs/svg/my/update_password.svg" />
          </span>

          <span class="info_title">{{ $t('修改密码') }}</span>

          <v-icon class="info_button_icon_right">keyboard_arrow_right</v-icon>
        </div>
      </v-flex>
      <v-flex v-if="getPlatform() != 'browser'" class="info_button" xs12 @click="onCheckAPKUpdate()">
        <!-- <v-flex class="info_button" xs12 @click="onCheckAPKUpdate()"> -->
        <div>
          <span style="height: 28px; line-height: 28px">
            <img style="height: 24px; width: 24px; vertical-align: middle" src="imgs/svg/my/update_version.svg" />
          </span>

          <span class="info_title">{{ $t('版本更新检查') }}</span>
          <v-icon class="info_button_icon_right">keyboard_arrow_right</v-icon>
        </div>
      </v-flex>
      <!-- <v-flex
        v-if="getPlatform() != 'browser'"
        class="info_button"
        xs12
        @click="onClearCache()"
      >
        <div>
          <span style="height: 28px; line-height: 28px">
            <img
              style="height: 24px; width: 24px; vertical-align: middle"
              src="imgs/svg/my/clean_cache.svg"
            />
          </span>

          <span class="info_title">清理缓存</span>
          <v-icon class="info_button_icon_right">keyboard_arrow_right</v-icon>
        </div>
      </v-flex> -->
      <v-flex class="info_button" xs12 @click="onAbout()">
        <div>
          <span style="height: 28px; line-height: 28px">
            <img style="height: 24px; width: 24px; vertical-align: middle" src="imgs/svg/my/about.svg" />
          </span>

          <span class="info_title">{{ $t('关于') + $t(displayName) }}</span>
          <v-icon class="info_button_icon_right">keyboard_arrow_right</v-icon>
          <!-- <span style="width: calc(100% - 180px); float: right">
            <span class="info_info"> 版本v{{ appDispVersion }} </span>
          </span> -->
        </div>
      </v-flex>
      <v-flex class="info_button" style="margin-top: 10px; margin-bottom: 10px" xs12 @click="onLogout()">
        <div style="
            width: 100%;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #383838;
          ">
          {{ $t('退出登录') }}
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import devHelper from '../util/devHelper'
import debugHelper from '../util/debug'
import dbHelper from '../util/db'
import tools from '../util/tools'
import { URLS } from '../util/urls'
import msgbus from '../msgBus'
import funcListConfig from '../funcListConfig'
import swal from 'sweetalert2'
import functions from '../functions'
import eDSCompLanguage from '../components/eDSCompLanguage.vue'

export default {
  name: 'iDS-MyAccountInfo',
  components: {
    eDSCompLanguage,
  },
  data: () => ({
    myinfo: {
      photo: '',
    },
    picNo: 0,
  }),
  watch: {},
  computed: {
    ...mapGetters('app', [
      'displayName'
    ]),
    appDispVersion() {
      return msgbus.vm.getAppDispVersion()
    },
    height() {
      return (
        `calc(${window.innerHeight
        }px - ${msgbus.vm.getContentBottomHeight()} ` + ')'
      )
    },
    textHeight() {
      return (
        `calc(${window.innerHeight
        }px - ${msgbus.vm.getContentBottomHeight()}  - 460px ` + ')'
      )
    },
  },
  methods: {
    onAbout() {
      this.$router.push({ name: 'about' })
    },
    onLogout() {
      tools.startFuncList(msgbus, this, funcListConfig.common.logout)
    },
    onSetPassword() {
      this.$router.push({ name: 'updatepwd' })
    },
    mSetParams(funcList) {
      return funcList
    },
    mGetResult(funcList) {
      return funcList
    },
    changeDataFormat(accountInfo) {
      var tmp = Object()
      tmp.name = accountInfo.name
      tmp.job = ''
      tmp.photo =
        accountInfo.avatar == null || accountInfo.avatar == ''
          ? 'imgs/svg/eds/user-icon-default.svg'
          : URLS.FILE_BASE_URL +
          accountInfo.avatar +
          '?token=' +
          msgbus.vm.getFstoken()
      if (accountInfo.mobileNo) {
        tmp.phone =
          accountInfo.mobileNo.substring(0, 3) +
          '****' +
          accountInfo.mobileNo.substring(7)
      } else {
        tmp.phone =
          accountInfo.email
      }
      return tmp
    },
    // 版本更新检查
    onCheckAPKUpdate() {
      functions.versionCheckHelper.funcClickCheckAPKUpdate()
    },
    //清理缓存
    onClearCache() {
      functions.versionCheckHelper.funcClearApkCache('')
    },
    changeView() {
      msgbus.vm.setTitleList({
        visible: false,
        list: [],
        listIcon: [],
        change: () => { },
        curValue: '',
        curIcon: '',
      })
      msgbus.vm.setToolbarDisabled(true)
      msgbus.vm.setBackDisabled(true)
      msgbus.vm.setBackIcon('')
      msgbus.vm.setBottomNavVisible(true)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setContentHeight({
        value:
          `calc(${window.innerHeight
          }px - ${msgbus.vm.getContentBottomHeight()} ` + ')',
      })
    },
    ...mapGetters('app', ['getPlatform']),
  },
  created: function () {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }
    var accountInfo = msgbus.vm.getAccountInfo()
    this.myinfo = this.changeDataFormat(accountInfo)
    this.changeView()

    // 获取显示版本信息
    functions.versionCheckHelper.funcGetAppDispVersion()
  },
  beforeDestroy() {
    msgbus.vm.setToolbarDisabled(false)
    msgbus.vm.setContentHeight({
      value:
        `calc(${window.innerHeight
        }px - 48px - ${msgbus.vm.getContentBottomHeight()} ` + ')',
    })
  },
}
</script>

<style lang="scss">
.account_infolist {
  background: #f3f4f6;

  .info_button {
    padding: 10px 0px 10px 10px;
    background: white;
    margin-bottom: 1px;
    font-family: PingFangSC-Medium;
    font-size: 16px;

    div p {
      float: left;
      margin-bottom: 0px;
      margin-left: 5px;
    }

    .blue-block {
      display: block;
      float: left;

      margin: {
        left: 0.5rem;
        right: 0.2rem;
      }
    }

    &>div>span {
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      float: left;
      max-width: calc(100% - 5rem);
    }

    .info_button_icon_left {
      float: left;
    }

    .info_button_icon_right {
      float: right;
      margin-right: 10px;
      line-height: 30px;
    }
  }

  .info_name_job_phone {
    height: 100px;
    background: #ffffff;
  }

  .info_name_job_phone {
    padding: 20px 0 20px 20px;
    display: flex;

    .img-bg {
      height: 60px;
      width: 60px;
      background: #1d80dd;
      border-radius: 50%;
      padding: 5px;

      img {
        height: 50px;
        width: 50px;
      }
    }
  }

  .name_job_phone {
    flex: 1;
    margin-left: 20px;
  }

  .info_name {
    //font-weight: bold;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #505050;
    letter-spacing: 0.24px;
    text-align: center;
  }

  .info_phone {
    opacity: 0.8;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #8a8a8f;
    letter-spacing: 0.19px;
  }

  .info_title {
    height: 30px;
    line-height: 30px;
    margin-left: 5px;
  }

  .info_info {
    color: grey;
    float: right;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    width: 100%;
    text-align: right;
  }

  .myinfo__dialog {
    .dialog-title {
      width: 100%;
      font-size: 1.7rem !important;
      text-align: center;
    }

    .leave-reason-list {
      position: absolute;
      z-index: 1000;
      font-size: 1rem;
      width: calc(100% - 4.7rem);

      border: {
        left: {
          style: solid;
          width: 2px;
          color: #dddddd;
        }

        right: {
          style: solid;
          width: 2px;
          color: #dddddd;
        }

        top: {
          style: solid;
          width: 2px;
          color: #dddddd;
        }
      }

      bottom: 2rem;
      right: 0.3rem;

      background: white;
      height: 5rem;
      overflow: auto;
      -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

      .leave-reason {
        padding: 0 1rem;

        .clear-icon {
          float: right;
          margin-right: 40px;
        }
      }
    }

    .v-card__text {
      padding: 0 6px;

      .container {
        padding: 0 16px;

        .form-title {
          float: left;
          font-size: 1rem;
        }

        .remove-min-height {
          min-height: 0;
          padding: 0 0rem 0 0;
          margin: 0px;

          .v-input__control {
            min-height: 0px;

            .v-input__slot {
              margin: 0;
              height: 1.5rem;

              .v-label {
                font-size: 1rem;
              }

              input {
                padding: 0;
                max-height: inherit;
                line-height: inherit;
                font-size: 1rem;
              }

              .v-text-field__suffix {
                font-size: 1.1rem;
              }
            }
          }
        }
      }
    }

    .hide-message {
      .v-text-field__details {
        display: none;
      }
    }

    .isSelected {
      padding: 0.1rem 0.5rem;
      background: #1890ff;
      color: white;
      border: solid;
      border-color: #1890ff;
      border-width: 1px;
    }

    .isNotSelected {
      padding: 0.1rem 0.5rem;
      border: solid;
      border-color: #1890ff;
      border-width: 1px;
    }

    .no-right-border {
      border: {
        right: {
          style: none;
        }
      }
    }
  }

  .myinfo__about__dialog {
    .dialog-title {
      width: 100%;
      font-size: 1.5rem !important;
      text-align: center;
    }

    .prop-title {
      font-size: 1.2rem;
    }

    .prop-value {
      font-size: 1.2rem;
    }

    .leave-reason-list {
      position: absolute;
      z-index: 1000;
      font-size: 1rem;
      width: calc(100% - 4.7rem);

      border: {
        left: {
          style: solid;
          width: 2px;
          color: #dddddd;
        }

        right: {
          style: solid;
          width: 2px;
          color: #dddddd;
        }

        top: {
          style: solid;
          width: 2px;
          color: #dddddd;
        }
      }

      bottom: 2rem;
      right: 0.3rem;

      background: white;
      height: 5rem;
      overflow: auto;
      -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

      .leave-reason {
        padding: 0 1rem;

        .clear-icon {
          float: right;
          margin-right: 40px;
        }
      }
    }

    .v-card__text {
      padding: 0 6px;

      .container {
        padding: 0 16px;

        .form-title {
          float: left;
          font-size: 1rem;
        }

        .remove-min-height {
          min-height: 0;
          padding: 0 0rem 0 0;
          margin: 0px;

          .v-input__control {
            min-height: 0px;

            .v-input__slot {
              margin: 0;
              height: 1.5rem;

              .v-label {
                font-size: 1rem;
              }

              input {
                padding: 0;
                max-height: inherit;
                line-height: inherit;
                font-size: 1rem;
              }

              .v-text-field__suffix {
                font-size: 1.1rem;
              }
            }
          }
        }
      }
    }

    .hide-message {
      .v-text-field__details {
        display: none;
      }
    }

    .isSelected {
      padding: 0.1rem 0.5rem;
      background: #1890ff;
      color: white;
      border: solid;
      border-color: #1890ff;
      border-width: 1px;
    }

    .isNotSelected {
      padding: 0.1rem 0.5rem;
      border: solid;
      border-color: #1890ff;
      border-width: 1px;
    }

    .no-right-border {
      border: {
        right: {
          style: none;
        }
      }
    }
  }
}
</style>
